import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { IEmails } from '../../../reportsContext/reportsState/reportsContext';
import { Rule } from 'antd/lib/form';
import FormInput from 'components/Input/FormInput';
import AddEmailBtn from './AddEmailBtn';
import breadcrumbs from 'assets/img/breadcrumbs.svg';
import style from './EmailsBlock.module.scss';

interface IEmailsBlock {
	addEmails: (value: IEmails) => void;
	changeEmails(emailId: string, email: string): void;
	deleteEmails(emailId: string): void;
	emails: IEmails[];
}

const EmailsBlock: React.FC<IEmailsBlock> = ({ addEmails, changeEmails, deleteEmails, emails }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(
		() => [
			{ required: true, message: t('enterEmail') },
			{
				type: 'email',
				message: t('invalidEmail'),
			},
		],
		[t],
	);

	const emailsList = useMemo(() => {
		return emails.map((el, i) => {
			const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
				e.target.maxLength = 128;
				changeEmails(el.id, e.target.value);
			};

			return (
				<div className={style.inputWrapper} key={el.id}>
					<FormInput
						testId={`EmailField-${el.id}`}
						name={el.id}
						label="emailMainRecipientLabel"
						getValueFromEvent={handleChange}
						validationRules={validationRules}
					/>
					{i !== 0 && (
						<svg className={style.deleteIcon} onClick={() => deleteEmails(el.id)}>
							<use xlinkHref={`${breadcrumbs}#close`} />
						</svg>
					)}
				</div>
			);
		});
	}, [changeEmails, deleteEmails, emails, validationRules]);

	return (
		<div className={style.container}>
			<div className={style.inputsContainer}>{emailsList}</div>
			<AddEmailBtn addEmails={addEmails} />
		</div>
	);
};

export default React.memo(EmailsBlock);
